import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Injectable({
    providedIn: 'root',
})
export class AuthRedirectGuard implements CanActivate {
    constructor(private readonly router: Router, private readonly authService: AuthService) {}

    canActivate(): boolean {
        const token = this.authService.getToken();
        // Use the isTokenExpired method to check if the token is expired
        const isValid = !this.authService.isTokenExpired(this.authService.getToken());
        if (isValid) {
            // Token exists and is valid, redirect to dashboard
            this.router.navigate(['/dashboard']);
            return false;
        } else {
            // No token or invalid token, allow access to the login page
            // Clear any existing invalid tokens
            if (token) {
                this.authService.removeToken();
            }
            return true;
        }
    }
}
